import axios from "axios";

interface IResposne {
  CLOUD_STORAGE_BUCKET_NAME: string;
}

export const loadEnv = async (): Promise<IResposne> => {
  const resp = await axios.get("/env.json");
  return resp.data;
}